import React, { Component } from "react";
import { connect } from "react-redux";
import { graphql, navigate } from "gatsby";
import { withStyles } from "@material-ui/styles";
import {
  savePubSearchDataByName,
  savePubSearchDataByLocation,
  savePubSearchQuery,
} from "../../../app/action";
import styles from "./CgbFindPubBlock.styles";
import FiltersFull from "./FiltersFull";
import FiltersSimple from "./FiltersSimple";

const mapDispatchToProps = (dispatch) => ({
  savePubSearchDataByName: (data) => dispatch(savePubSearchDataByName(data)),
  savePubSearchDataByLocation: (data) =>
    dispatch(savePubSearchDataByLocation(data)),
  savePubSearchQuery: (query) => dispatch(savePubSearchQuery(query)),
});

const mapStateToProps = (state) => ({
  pubSearchQuery: state.pubSearch.query,
});

const connector = connect(mapStateToProps, mapDispatchToProps);

class CgbFindPub extends Component {
  state = {
    data: [],
    filterOpen: false,
  };

  constructor(props) {
    super(props);

    this.loadData = this.loadData.bind(this);
  }

  loadData(query) {
    this.props.savePubSearchQuery(query);
    navigate("/search-results", { state: { query } });
  }

  toggleFilter() {
    this.setState({
      filterOpen: !this.state.filterOpen,
    });
  }

  render() {
    const { classes, attributes, overlap, pubSearchQuery } = this.props;
    const classNames = `
      ${attributes.className ? attributes.className : ""}
      ${overlap ? "overlap-top" : ""}
      ${this.props.hasMap ? classes.FindPubWithMap : classes.FindPub} ${
      classes.FindPubTheme
    }
    `;

    return (
      <section className={`find-a-pub ${classNames}`}>
        {!attributes.simpleSearch && (
          <FiltersFull
            classes={classes}
            loadData={this.loadData}
            prefillValues={pubSearchQuery}
            hasMap={this.props.hasMap}
          />
        )}
        {attributes.simpleSearch && (
          <FiltersSimple
            classes={classes}
            introText={attributes.introText}
            loadData={this.loadData}
            prefillValues={pubSearchQuery}
          />
        )}
      </section>
    );
  }
}

export const CgbFindPubBlock = withStyles(styles)(connector(CgbFindPub));

export default CgbFindPubBlock;

export const CgbFindPubBlockFragment = graphql`
  fragment CgbFindPubBlock on WpBlock {
    ... on WpCgbFindPubBlock {
      name
      attributes {
        className
        simpleSearch
        introText
      }
    }
  }
`;

// This is the string version of this that is used within previews and without WP prefixes
export const CgbFindPubBlockPreview = `
    ... on CgbFindPubBlock {
        name
        attributes {
            className
            simpleSearch
            introText
        }
    }
`;
